// removed by extract-text-webpack-plugin
module.exports = {"root":"btzTWptKktXRo-kptHmzr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SaveButton/styles.css
// module id = 1077
// module chunks = 0